module.exports = __webpack_public_path__ + "media/saint_Elme_loop_480.94cad7b5.mp4";